import styled from "styled-components";
import { colors } from "../../../../../assets/styles";

export const Container = styled.div``;

export const Header = styled.div``;

export const HeaderItem = styled.div``;

export const HeaderTitle = styled.span`
  ${(props) => props.theme.isDarkTheme && `color: ${colors.textColorBlackFive}`}
`;

export const HeaderLevel = styled.span``;

export const ItemText = styled.span`
  ${(props) => props.theme.isDarkTheme && `color: ${colors.textColorBlackFive}`}
`;

export const ItemIcon = styled.span`
  color: ${(props) =>
    props.theme.isDarkTheme
      ? colors.textColorBlackFive
      : colors.textColorBlackFor};
`;

export const SettingContainer = styled.div``;

export const SettingTitle = styled.span``;

export const SettingContainerItem = styled.div``;

export const SettingContainerItemRight = styled.span`
  ${(props) => props.theme.isDarkTheme && `color: ${colors.textColorBlackFive}`}
`;

export const SettingContainerItemLeft = styled.span``;
